export default "__VITE_PUBLIC_ASSET__bb1672e6__"